import { notify } from 'utils/reduxUtils';

export const types = {
  SES_VERIFICATION_FAILURE_MODAL_CLOSE:
    'common/modals/sesVerificationFailureModal/SES_VERIFICATION_FAILURE_MODAL_CLOSE',
  SES_VERIFICATION_FAILURE_MODAL_OPEN:
    'common/modals/sesVerificationFailureModal/SES_VERIFICATION_FAILURE_MODAL_OPEN',
  RESEND_SES_VERIFICATION_EMAIL_ERROR:
    'common/modals/sesVerificationFailureModal/RESEND_SES_VERIFICATION_EMAIL_ERROR',
  RESEND_SES_VERIFICATION_EMAIL_REQUEST:
    'common/modals/sesVerificationFailureModal/RESEND_SES_VERIFICATION_EMAIL_REQUEST',
  RESEND_SES_VERIFICATION_EMAIL_SUCCESS:
    'common/modals/sesVerificationFailureModal/RESEND_SES_VERIFICATION_EMAIL_SUCCESS',
};

export const sesVerificationFailureModal = {
  close: () => ({
    type: types.SES_VERIFICATION_FAILURE_MODAL_CLOSE,
  }),
  open: () => ({
    type: types.SES_VERIFICATION_FAILURE_MODAL_OPEN,
  }),
};

export const resendSesVerificationEmail = {
  error: notify(
    ({ error }) => ({
      type: types.RESEND_SES_VERIFICATION_EMAIL_ERROR,
      payload: error,
    }),
    'Something went wrong when sending the verification email.',
  ),
  request: () => ({
    type: types.RESEND_SES_VERIFICATION_EMAIL_REQUEST,
  }),
  success: notify(
    () => ({
      type: types.RESEND_SES_VERIFICATION_EMAIL_SUCCESS,
    }),
    'Verification email sent.',
  ),
};
